import { useTranslation } from '@/features/shared/composables/useTranslation'
import { ACCOUNT_TYPE } from '@/features/shared/constants/accountType'
import { PERMISSIONS } from '@/features/shared/constants/permissions'

const t = useTranslation()

export const listingTrackingRoutes = [
  {
    path: 'listings/:listingId/tracking',
    name: 'ListingTracking',
    component: () => import('@/features/listingTracking/views/ListingTracking.vue'),
    meta: {
      mainRouteName: 'Listings',
      title: `${t('listing_tracking')} | Pour Now`,
      permissionsIdentifiers: [PERMISSIONS.CAN_UPDATE_LISTING],
      visibleAccountTypes: [ACCOUNT_TYPE.BRAND],
    },
  },
]
